import memoize from 'fast-memoize';
import * as React from 'react';
import { memo } from 'react';

export type ProgressItemProps = {
	progress: string;
};

export type ProgressProps = {
	activeStep: number;
	stepLength: number;
};

export const generateBarProgress = memoize((activeStep: number, lastStep: number): ProgressItemProps[] => {
	const bar = Array(lastStep).fill({});

	for (let i = 0; i < activeStep; i++) {
		bar[i] = {
			progress: 'done',
		};
	}

	bar[activeStep] = {
		progress: 'current',
	};

	return bar;
});

export class Progress extends React.Component<ProgressProps> {
	public static displayName = 'Progress';

	public static defaultProps = {
		activeStep: 0,
		stepLength: 0,
	};

	public renderProgressItem(item: ProgressItemProps, index: number) {
		const classes: string[] = ['m-progress__step'];

		if (typeof item.progress === 'string') {
			classes.push(`m-progress__step--${item.progress}`);
		}

		return <li key={index} className={classes.join(' ')} />;
	}

	public render() {
		const { activeStep, stepLength } = this.props;

		return (
			<ol className="m-progress">{generateBarProgress(activeStep, stepLength).map(this.renderProgressItem)}</ol>
		);
	}
}

export default memo(Progress);
